module.exports = __webpack_public_path__ + "media/images/flags/32/San-Marino-a16a8e171e6803273eb5fe1ae85ae80b.png";